import get from 'lodash.get';

/**
 * Gets the menu node based on the provided path from the
 * menu's tree data structure
 */
export var getMenuNode = function getMenuNode(menu, path) {
  if (!path.length) {
    return menu;
  }

  return get(menu.children, path.join('.children.'));
};